import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import PageHero from '../components/PageHero'

const IMAGES = ['1.jpeg','17.jpeg','3.jpeg','29.jpeg','8.jpeg','22.jpeg','14.jpeg','35.jpeg',
  '27.jpeg','10.jpeg','31.jpeg','6.jpeg','19.jpeg','40.jpeg','12.jpeg','24.jpeg',
  '5.jpeg','33.jpeg','16.jpeg','2.jpeg','28.jpeg','21.jpeg','9.jpeg','36.jpeg',
  '15.jpeg','4.jpeg','26.jpeg','11.jpeg','34.jpeg','18.jpeg','7.jpeg','25.jpeg',
  '39.jpeg','13.jpeg','30.jpeg','20.jpeg','38.jpeg','23.jpeg','32.jpeg','37.jpeg']

export default function Impact() {
  return (
    <>
      <Navbar />
      <PageHero
        title="Our Impact"
        subtitle="Measuring success beyond the pitch — transforming lives through football, education, and opportunity."
        variant="impact"
        fadeClass="fade-in"
      />

      <main>
        {/* Stats (dark green) */}
        <section className="impact-section bg-brand" style={{ padding: 'var(--space-16) 0' }}>
          <div className="container">
            <div className="section-header fade-in">
              <span className="eyebrow" style={{ color: 'var(--color-accent-light)' }}>By the Numbers</span>
              <h2 style={{ color: 'white' }}>
                Our <span style={{ color: 'var(--color-accent)' }}>Impact</span> So Far
              </h2>
              <div className="section-divider"></div>
              <p className="section-lead" style={{ marginTop: '1.5rem', color: 'rgba(255,255,255,0.8)' }}>
                Every program, every child reached, and every school engaged reflects our
                commitment to shaping brighter futures through education and football.
              </p>
            </div>

            <div className="grid-4 fade-in-stagger" style={{ marginBottom: '3rem' }}>
              <div className="stat-card impact-bg">
                <span className="stat-number gold-gradient-text glow counter" data-target="500">0</span>
                <p>Children Reached</p>
              </div>
              <div className="stat-card impact-bg">
                <span className="stat-number gold-gradient-text glow counter" data-target="10">0</span>
                <p>Partner Schools</p>
              </div>
              <div className="stat-card impact-bg">
                <span className="stat-number gold-gradient-text glow counter" data-target="3">0</span>
                <p>Communities Served</p>
              </div>
              <div className="stat-card impact-bg">
                <span className="stat-number gold-gradient-text glow counter" data-target="1">0</span>
                <p>Country So Far</p>
              </div>
            </div>

            <div className="text-center fade-in">
              <a href="/programs" className="btn btn-accent btn-lg">
                See Our Programs <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </section>

        {/* Beyond the Numbers */}
        <section className="section fade-in">
          <div className="container">
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4rem', alignItems: 'center' }}>
              <div>
                <span className="eyebrow">Beyond the Numbers</span>
                <h2 style={{ marginTop: '0.5rem', marginBottom: '1.5rem' }}>
                  Real Lives, <span className="text-accent">Real Change</span>
                </h2>
                <p>Our impact cannot be measured by statistics alone.
                Behind every program is a child who has found confidence,
                purpose, and hope. A child who no longer has to choose
                between education and football. A child who is learning to
                believe in a future filled with possibilities.</p>
                <p style={{ marginTop: '1rem' }}>Through our school-based approach, we create safe spaces where dreams are nurtured responsibly,
                talents are guided with care, and education remains the foundation.
                We reach boys and girls who might otherwise be overlooked,
                giving them structure, mentorship, and the reassurance that
                their worth extends far beyond the pitch.</p>
                <p style={{ marginTop: '1rem' }}>Every story we touch is a reminder that when children are supported holistically,
                communities grow stronger, futures become brighter, and lives are changed for good.</p>
              </div>
              <div>
                <img
                  src="/images/story.jpeg"
                  className="img-fluid"
                  alt="Children training"
                  style={{ borderRadius: 'var(--radius-xl)', boxShadow: 'var(--shadow-xl)', width: '100%' }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* How programs make a difference */}
        <section className="section bg-light fade-in">
          <div className="container">
            <div className="section-header">
              <span className="eyebrow">Program Impact</span>
              <h2>How Our <span className="text-accent">Programs</span> Make a <span className="text-accent">Difference</span></h2>
              <div className="section-divider"></div>
            </div>

            <div className="grid-3 fade-in-stagger" style={{ marginTop: '3rem' }}>
              <div className="info-card">
                <div className="icon-badge">
                  <i className="bi bi-building" style={{ fontSize: '1.4rem', color: 'var(--color-primary)' }}></i>
                </div>
                <h4>School-Based Football</h4>
                <p>Our programs are delivered directly within schools,
                ensuring children can pursue their passion for football
                without sacrificing their education. By aligning training
                schedules with academic learning, we help students develop
                discipline, focus, and time management &mdash; skills that strengthen
                both classroom performance and athletic growth.</p>
              </div>

              <div className="info-card">
                <div className="icon-badge">
                  <i className="bi bi-briefcase" style={{ fontSize: '1.4rem', color: 'var(--color-primary)' }}></i>
                </div>
                <h4>Career Pathways Beyond Football</h4>
                <p>SISDI goes beyond football by equipping children with practical,
                transferable skills that expose them to opportunities in multiple
                career paths. Through mentorship, guidance, and education-focused
                initiatives, we help young players understand their strengths, explore
                alternative careers, and prepare for life beyond the pitch.</p>
              </div>

              <div className="info-card">
                <div className="icon-badge">
                  <i className="bi bi-people-fill" style={{ fontSize: '1.4rem', color: 'var(--color-primary)' }}></i>
                </div>
                <h4>Inclusive and Equal Opportunities</h4>
                <p>Our programs create access for both boys and girls,
                especially in underserved communities where opportunities
                are limited. By integrating football into schools, we remove
                financial and cultural barriers and promote equality,
                confidence, and community impact.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Photo slider */}
        <section className="impact-slider-section fade-in" style={{ position: 'relative' }}>
          <div className="container">
            <div className="section-header" style={{ marginBottom: '3rem' }}>
              <span className="eyebrow" style={{ color: 'var(--color-accent-light)' }}>Gallery</span>
              <h2 style={{ color: 'white' }}>Impact in Motion</h2>
              <div className="section-divider"></div>
            </div>

            <div style={{ position: 'relative' }}>
              <button className="slider-btn slider-prev" aria-label="Previous">
                <i className="bi bi-chevron-left"></i>
              </button>
              <button className="slider-btn slider-next" aria-label="Next">
                <i className="bi bi-chevron-right"></i>
              </button>

              <div className="impact-slider" id="impactSlider">
                <div className="impact-track">
                  {IMAGES.map((f) => (
                    <img key={f} src={`/images/${f}`} alt="" className="image-card" />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="section text-center fade-in">
          <div className="container">
            <span className="eyebrow">Make a Difference</span>
            <h2 className="cta-text" style={{ color: 'var(--color-dark)', marginTop: '0.5rem' }}>
              <span>Be Part of the Impact</span>
            </h2>
            <p style={{ maxWidth: '600px', margin: '1rem auto 2rem', fontSize: '1.05rem' }}>
              Join us in transforming young lives through education and football.
              Your support helps create opportunity, confidence, and hope where it&apos;s needed most.
            </p>
            <a href="/get-involved" className="btn btn-primary btn-lg">
              <i className="bi bi-heart-fill"></i> Get Involved
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </>
  )
}
